module.exports = __webpack_public_path__ + "static/media/register.8bcb35d6.svg";